S.gallery = {
    config: {
        // BUG preview bei loop
        loop: false,
        speed: 600,
        language: 'de',
    },

    elements: {
        $swiperContainer: null,
    },

    // var {jQuery} $swiper
    $swiper: null,

    init()
    {
        this.initSwiper();

        // Pfeile vertical zentrieren
        // type: 1=eckig | 2=rund
        S.swiperset.setArrows('.mod-gallery', 2);
    },

    initSwiper()
    {
        // get area-label Text Arrows (prevSlideMessage/nextSlideMessage)
        const slideMessageArray = S.swiperset.getSlideMessage(this.config.language);

        // https://swiperjs.com/swiper-api
        this.$swiper = new Swiper(this.elements.$swiperContainer.get(0), {
            slidesPerView: 1,
            slidesPerGroup: 1,
            // spaceBetween: 30,
            speed: this.config.speed,
            centeredSlides: false,
            loop: this.config.loop,
            // calculateHeight: true,
            // https://swiperjs.com/swiper-api#param-preventClicks
            // https://swiperjs.com/swiper-api#param-preventClicksPropagation
            // wenn Bild nicht verlinkt auf false setzen
            // Barrierefreiheit sonst Image im Screenreader verlinkt
            preventClicks: false,
            preventClicksPropagation: false,

            // 7.0.0 +
            // Enable this feature to calculate each slides progress and visibility (slides in viewport will have additional visible class)
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,


            // autoplay: {
            //     delay: 3000,
            // },

            keyboard: {
                enabled: true,
            },

            // pagination optional
            pagination: {
                el: this.$module.find('.swiper-pagination').get(0),
                clickable: true,
                // type: 'fraction',
            },

            navigation: {
                nextEl: this.$module.find('.swiper-button-next').get(0),
                prevEl: this.$module.find('.swiper-button-prev').get(0),
            },

            a11y: {
                prevSlideMessage: slideMessageArray['prev'],
                nextSlideMessage: slideMessageArray['next'],
            },

            on: {
                init: () =>
                {
                    // remove double iDs
                    S.swiperset.removeDuplicateId();
                },

                slideChange: () =>
                {
                    // stop video/audio
                    S.swiperset.resetsrc(this.$module);
                },
            },
        });
    },
};
